import React, { useState, useEffect } from 'react';
import { usersAPI } from '../../services/api';
import './OnlineUsers.css';

const OnlineUsers = () => {
  const [onlineUsers, setOnlineUsers] = useState([]);

  useEffect(() => {
    const fetchOnlineUsers = async () => {
      try {
        const response = await usersAPI.getOnline();
        setOnlineUsers(response.data);
      } catch (error) {
        console.error('Failed to fetch online users:', error);
      }
    };

    // Fetch immediately
    fetchOnlineUsers();

    // Poll every 30 seconds
    const interval = setInterval(fetchOnlineUsers, 30000);

    return () => clearInterval(interval);
  }, []);

  if (onlineUsers.length === 0) {
    return null;
  }

  return (
    <div className="online-users-container">
      <div className="online-users-list">
        {onlineUsers.map((user) => (
          <div key={user.id} className="online-user-item">
            <span className="online-dot"></span>
            <span className="online-username">{user.username}</span>
            <span className="online-status">Online</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OnlineUsers;
